import ajax from "./ajax"

let promise = null

// Reset promise when Turbo navigates to ensure fresh token requests
document.addEventListener("turbo:before-cache", () => {
  promise = null
})

document.addEventListener("turbo:load", () => {
  promise = null
})

function refreshAuthenticityToken() {
  if (promise) return promise

  promise = ajax.get("/authenticity_token")
    .then(updateAuthenticityToken)
    .catch(() => {
      promise = null
    })
  return promise
}

// refreshing the meta headers + all form inputs
// (also see https://github.com/rails/jquery-ujs)
function updateAuthenticityToken({token}) {
  const meta = document.querySelector("meta[name='csrf-token']")
  meta?.setAttribute("content", token)
  const inputs =
    document.querySelectorAll("form input[name='authenticity_token']")
  for (const input of inputs) {
    input.setAttribute("value", token)
  }
  return token
}

export function getCsrfTokenFromDoc() {
  const meta = document.querySelector("meta[name='csrf-token']")
  return meta?.content
}

// used be the tests to reset the promise
export function resetPromise() {
  promise = null
}

export default refreshAuthenticityToken
